import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-revolution-slider4',
  templateUrl: './revolution-slider4.component.html'
})
export class RevolutionSlider4Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
